import axios from 'axios'
import { apiError } from '../../components/features/errorBoundary/ErrorBoundary'
import i18n, { defaultContur } from '../../translations'
import { initInterceptorsApm } from './apm'
import { CONTURS_API_TIMEOUT } from '../config'

const prefix = `${process.env.API_URL ?? ''}/api/v1`

const pendingRequests = new Map()

function makeRequestKey(config) {
  const method = (config.method || 'get').toLowerCase()
  const url = config.url || ''
  return `${method}|${url}`
}

function isAbsolute(str) {
  return /^(\w+:)?\/\//.test(str)
}

function hasPrefix(method, prefix) {
  return prefix && method.indexOf(prefix) === 0
}

function getURL(method) {
  if (isAbsolute(method) || hasPrefix(method, prefix)) {
    return method
  }

  return `${prefix}${method}`
}

function initMethod(method) {
  return (apiMethod, data = {}, options = {}) =>
    send({
      method,
      apiMethod,
      data,
      ...options,
    })
}

let globalHeaders = {}

export function addHeaders(_headers) {
  Object.keys(_headers).forEach((key) => {
    if (_headers[key] === undefined) {
      delete globalHeaders[key]
    } else {
      globalHeaders[key] = _headers[key]
    }
  })
}

export const get = initMethod('get')
export const post = initMethod('post')

// Создаем экземпляр Axios с перехватчиками
const apiClient = axios.create()

initInterceptorsApm(apiClient)

export function send(config) {
  const { skipDeduplication = false, ...requestOptions } = config
  const requestConfig = {
    ...requestOptions,
    timeout: requestOptions.timeout || CONTURS_API_TIMEOUT[defaultContur],
    headers: {
      ...globalHeaders,
      ...requestOptions?.headers,
      lang: i18n.language,
    },
    url: getURL(requestOptions.apiMethod),
  }

  const key = makeRequestKey(requestConfig)

  if (!skipDeduplication) {
    // Если уже есть такой pending — прерываем его
    const prev = pendingRequests.get(key)
    if (prev) {
      prev.abort()
      pendingRequests.delete(key)
    }
  }

  const controller = new AbortController()
  requestConfig.signal = controller.signal

  if (!skipDeduplication) pendingRequests.set(key, controller)

  return apiClient(requestConfig)
    .then(onSuccess, onFail)
    .finally(() => {
      if (skipDeduplication) return

      const cur = pendingRequests.get(key)
      if (cur === controller) pendingRequests.delete(key)
    })
}

/**
 *
 * @param {{data, status, statusText, headers, config}} response
 * @return {*}
 */

function onSuccess(response) {
  const { data } = response
  if (data.success !== true) {
    const error = apiError(response)
    throw { error: error }
  }
  return data.data
}

function onFail(error) {
  const errorData = apiError(error)

  throw {
    error: errorData,
    response: error.response?.data || null,
  }
}

export function abortAllPendingRequests() {
  for (const controller of pendingRequests.values()) {
    controller.abort()
  }

  pendingRequests.clear()
}

// function onSuccess(response) {
//   const {data} = response;
//   if (ApiError.isError(data)) {
//     throw ApiError.fromApiResponse(data);
//   }
//   return data.data;
// }
//
// function onFail(error) {
//   if (error.response && typeof error.response.data === "object") {
//     throw ApiError.fromApiResponse(error.response.data);
//   } else if(error.request) {
//     throw ApiError.fromHttpError(error.request);
//   } else {
//     throw new ApiError({});
//   }
// }
